export default __webpack_public_path__ + "static/media/icon-notallow.33fa2617.svg";